import { EMPTINESS_SIGN } from 'rp-react-table';
import { isRunner } from '../horse/form/formTable/helper';

export const placesSort = key => (a, b) => {
    if (a[key] === 0) {
        return 1;
    }
    if (b[key] === 0) {
        return -1;
    }
    return a[key] - b[key];
};

export const numericAndDashSort = key => (a, b) => {
    // Hanlde non-runners
    if (!isRunner(a)) return 1;
    if (!isRunner(b)) return -1;

    // Handle cases with special rows ( N days break )
    if (a.isSpecial) return 1;
    if (b.isSpecial) return -1;

    // Show 0 values first
    if (a[key] === 0 && (b[key] === null || b[key] === EMPTINESS_SIGN)) return -1;
    if (b[key] === 0 && (a[key] === null || a[key] === EMPTINESS_SIGN)) return 1;

    // Show '-' after 0 values
    if (a[key] === EMPTINESS_SIGN && b[key] !== EMPTINESS_SIGN) return 1;
    if (b[key] === EMPTINESS_SIGN && a[key] !== EMPTINESS_SIGN) return -1;

    return b[key] - a[key];
};

export const zeroToDash = key => rowData => rowData[key] || EMPTINESS_SIGN;



// WEBPACK FOOTER //
// ./src/js/utils/number.js